export default __webpack_public_path__ + "static/media/031-mobile store.61369d8c.svg";